import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-easy-pie-chart',
	templateUrl:'./EasyPieChartPluginPage.html',
	styles: [],
	styleUrls:['./EasyPieChartPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class EasyPieChartPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_566 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>easy-pie-chart</artifactId>
</dependency>
\`\`\``;
	mdContent_567 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:easy-pie-chart")
\`\`\``;
	mdContent_568 = `\`\`\`java
var chart = new EasyPieChart<>();
chart.getOptions().setBarColor("#ef1e25");
\`\`\``;
	mdContent_569 = `\`\`\`java
var chart = new EasyPieChart<>();
chart.getOptions().setBarColor("#ef1e25").setTrackColor("#f9f9f9");
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
